import useSWR from 'swr';
import { CONSTANTS } from '@/constants';
import { mergeAPIError } from '@/utils/errors';
import { request } from '@/utils/request';

export function useClaimedDaily(address: string) {
  const response = useSWR(
    `${CONSTANTS.BASE_URL}/api/world-coin-chest-smasher/extra-eggs/daily-generate?wallet=${address}`,
    async (url: string) => {
      const res = await request(url);
      if (!res.ok) {
        const msg = await res
          .json()
          .then((e) => mergeAPIError(e))
          .catch((e) => e.message ?? res.statusText);
        throw new Error(`Failed with status ${res.status} :${msg}`);
      }

      const data = await res.json();
      return data as {
        success: boolean;
        message: string;
        code: string;
        innerMessage: string | null;
        data: boolean;
      };
    },
    {
      dedupingInterval: 2000,
    },
  );
  return response;
}
